import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import {
  SigninEmailValidateObject,
  SigninPasswordValidateObject,
  signinEmailValidateObject,
  signinPasswordValidateObject,
} from '../validate'

export const useSigninEmailForm = () => {
  const signinEmailFormObject = useForm<SigninEmailValidateObject>({
    defaultValues: {
      email: '',
    },
    mode: 'all',
    resolver: zodResolver(signinEmailValidateObject),
  })
  return { signinEmailFormObject }
}

export const useSigninPasswordForm = () => {
  const signinPasswordFormObject = useForm<SigninPasswordValidateObject>({
    defaultValues: {
      password: '',
    },
    mode: 'all',
    resolver: zodResolver(signinPasswordValidateObject),
  })
  return { signinPasswordFormObject }
}
